import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap;

export const initPopovers = () => {
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl, { html: true }))
}

export const initTooltips = () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl))
}

export const initializeBootstrapComponents = () => {
  initPopovers()
  initTooltips()
}

const eventsForBootstrapInitialization = ["turbo:load", "turbo:render", "turbo:frame-load", "tooltips-initialisieren"]
eventsForBootstrapInitialization.forEach((event) => {
  document.addEventListener(event, initializeBootstrapComponents)
})
